<template>
  <section v-if="role">
    <div
      :class="`flex ${
        isMobile ? 'flex-col' : 'max-h-fit gap-10'
      } justify-center`"
    >
      <ul :class="`flex topbar-li`" v-for="(item, i) in userItems()" :key="i">
        <div
          v-if="!isMobile"
          :class="[{active: item.name === routeName}, {active: item.groupRouteFrom && (item.groupRouteFrom === $route.meta.groupRouteFrom)}]"
        >
          <li class="pb-2 item-li">
            <Button class="btn-simple" @click="item.command">
              <v-icon :name="item.icon" class="text-primary-400 mr-2" />
              {{ $t("labels.generic", { pt: item.label, en: item.labelEN }) }}
            </Button>
          </li>
        </div>

        <li
          v-else
          class="bg-h-primary-100 rounded-md border mb-2 active:bg-h-secondary-100 w-full"
          @click="item.command"
        >
          <Button
            :label="item.label"
            icon="pi pi-angle-right"
            class="btn-simple p-button-sm"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts">
import { Roles } from "@/models/user.model";
import { GoToRoute } from "@/utils/go-to.util";
import { defineComponent } from "vue";
import { adm, master, student, teacher } from "./items.utils";

export default defineComponent({
  name: "NavItens",
  computed: {
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  props: {
    role: {
      required: true,
      type: String,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      routeName: "" as any,
    };
  },
  updated() {
    this.routeName = this.$route.name;
  },
  mounted() {
    this.routeName = this.$route.name;
  },
  unmounted() {
    this.routeName = "";
  },
  watch: {
    $route(val) {
      this.routeName = val.name;
    },
  },
  methods: {
    userItems(): Array<any> {
      return this.role?.includes(Roles.APPLICATION_ADMIN)
        ? [...master]
        : this.role?.includes(Roles.ADMINISTRATOR)
        ? [...adm]
        : this.role?.includes(Roles.TEACHER)
        ? [...teacher]
        : this.role?.includes(Roles.STUDENT)
        ? [...student]
        : [];
    },
  },
});
</script>
